import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_why-me-org/artifacts/qhc2a24j_WHYME%20LOGO.jpg" 
              alt="WHY ME Foundation" 
              className="h-12 w-auto"
            />
            <p className="text-gray-400 text-sm">
              Wisdom Helping Youth Maximize Everything
            </p>
            <p className="text-gray-400 text-sm">
              Empowering underprivileged youth through education, mentorship, and opportunity.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#E6B933]">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#E6B933] transition-colors duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/programs" className="text-gray-400 hover:text-[#E6B933] transition-colors duration-300">
                  Programs
                </Link>
              </li>
              <li>
                <Link to="/clubs" className="text-gray-400 hover:text-[#E6B933] transition-colors duration-300">
                  Clubs & Services
                </Link>
              </li>
              <li>
                <Link to="/get-involved" className="text-gray-400 hover:text-[#E6B933] transition-colors duration-300">
                  Get Involved
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#E6B933]">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-gray-400">
                <MapPin size={18} className="flex-shrink-0" />
                <span className="text-sm">7315 Five Forks Dr. Spring, TX 77379</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Mail size={18} className="flex-shrink-0" />
                <a href="mailto:thewhymefoundation@gmail.com" className="text-sm hover:text-[#E6B933] transition-colors duration-300">
                  thewhymefoundation@gmail.com
                </a>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Phone size={18} className="flex-shrink-0" />
                <a href="tel:+18325179969" className="text-sm hover:text-[#E6B933] transition-colors duration-300">
                  (832) 517-9969
                </a>
              </li>
            </ul>
          </div>

          {/* Social & Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#E6B933]">Connect With Us</h3>
            <div className="flex space-x-4 mb-6">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-[#E6B933] transition-all duration-300 hover:scale-110">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com/thewhymefoundation" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-[#E6B933] transition-all duration-300 hover:scale-110">
                <Instagram size={20} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-[#E6B933] transition-all duration-300 hover:scale-110">
                <Twitter size={20} />
              </a>
            </div>
            <p className="text-sm text-gray-400 mb-3">Subscribe to our newsletter</p>
            <div className="flex">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2 bg-gray-800 text-white rounded-l-lg focus:outline-none focus:ring-2 focus:ring-[#E6B933]"
              />
              <button className="px-4 py-2 bg-[#E6B933] hover:bg-[#D4A01F] rounded-r-lg transition-colors duration-300">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} The WHY ME Foundation. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-[#E6B933] text-sm transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-[#E6B933] text-sm transition-colors duration-300">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
